import {CustomFieldModel} from '../../../src/models/api/customFieldModel';

export function buildCustomFieldLabel(value: string, customFieldModel: CustomFieldModel): string | undefined {
  const enumValue = customFieldModel.enumValues?.find((ev) => ev.value === value);

  return enumValue?.label;
}
